import couponIndex from '@/pages/coupon/index.vue'
import couponList from '@/pages/coupon/couponList.vue'
import couponDetail from '@/pages/coupon/couponDetail.vue'

const appRoutes = [{
	path: '/coupon',
	redirect: '/coupon/couponList',
	component: couponIndex,
	children: [{
		path: 'couponList',
    name: 'couponList',
		component: couponList
	},{
		path: 'couponDetail',
    name: 'couponDetail',
		component: couponDetail
	}]
}]
export default appRoutes
